import React, { useContext } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import Fade from '@material-ui/core/Fade'
import { split, upperFirst } from 'lodash'

// components
import Button from '@material-ui/core/Button'
import Layout from '../layout'

// utils
import { getBaseUrl } from '../utils'

// styles
import { useStyles } from '../styles/common.style'

// store
import { Context } from '../store'

import { t } from 'application-translator/dist/translate/translate.react.js';

function Done() {
  const classes = useStyles()

  // globalState
  const { globalState } = useContext(Context)
  const { signedBy } = globalState.userData || {}

  // router hooks
  const location = useLocation()
  const history = useHistory()

  const goMainPage = () => {
    const { pathname } = location
    const baseUrl = getBaseUrl(pathname)

    history.push(`${baseUrl}`)
  }

  return (
    <Layout header={'test'} title="Done">
      <div className={classes.content}>
        <Fade
          in={true}
          style={{
            transitionDelay: '50ms',
          }}
          unmountOnExit
        >
          <Box textAlign="center" padding={2}>
            <svg
              width="65"
              height="64"
              viewBox="0 0 65 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M56.5 29.5467V32C56.4973 38.6267 53.8093 44.6213 49.46 48.9653C45.1106 53.3093 39.1133 55.9893 32.4866 55.984C25.86 55.9787 19.8626 53.2933 15.5213 48.944C11.18 44.5947 8.4973 38.6 8.49997 31.9707C8.50263 25.3413 11.1906 19.3493 15.54 15.0053C19.8893 10.6613 25.8866 7.98133 32.5133 7.984C36.06 7.98667 39.4093 8.75467 42.244 10.0507C43.5826 10.664 45.1666 10.072 45.7773 8.73333C46.388 7.39467 45.7986 5.81067 44.46 5.2C40.9213 3.584 36.8173 2.65333 32.516 2.65067C24.4173 2.64533 17.0786 5.928 11.7693 11.2293C6.45997 16.5307 3.17197 23.8693 3.16663 31.968C3.1613 40.0667 6.44397 47.4053 11.7453 52.7147C17.0466 58.024 24.3826 61.3147 32.4813 61.3173C40.58 61.32 47.9186 58.04 53.228 52.7387C58.5373 47.4373 61.828 40.1013 61.8333 32V29.5467C61.8333 28.0747 60.6386 26.88 59.1666 26.88C57.6946 26.88 56.5 28.0747 56.5 29.5467ZM57.2813 8.78133L32.5 33.5867L26.3853 27.4747C25.3426 26.432 23.6546 26.432 22.6146 27.4747C21.5746 28.5173 21.572 30.2053 22.6146 31.2453L30.6146 39.2453C31.6573 40.288 33.3453 40.2853 34.388 39.2453L61.0546 12.552C62.0946 11.5093 62.0946 9.82133 61.052 8.78133C60.0093 7.74133 58.3213 7.74133 57.2813 8.784V8.78133Z"
                fill="#73B944"
              />
            </svg>
          </Box>
        </Fade>

        <p>
          {t('Great work')} <strong>{upperFirst(split(signedBy, ' ', 1))}</strong>!
        </p>

        <p>
          {t('Get ready to workout with UBX. Please show this Tick of approval to your trainer, and let\'s get started!')}
        </p>

        <Button
          variant="contained"
          color="primary"
          type="button"
          onClick={goMainPage}
        >
          {t('Done')}
        </Button>
      </div>
    </Layout>
  )
}

export default Done
